/* Injecte les proprietes choisies (couleur, etc.) dans TOUT ajout au panier,
   que le theme utilise un envoi de formulaire classique ou un appel AJAX.
   Charge par la section Couleur acrylique. */
(function () {
  if (window.__gcpBridge) return;
  window.__gcpBridge = true;
  window.__gcpPickers = window.__gcpPickers || [];

  function matches(p, id) {
    if (!p.ids || !p.ids.length) return true;
    if (id === null || id === undefined || id === '') return true;
    return p.ids.indexOf(String(id)) !== -1;
  }

  function applyToItem(item) {
    window.__gcpPickers.forEach(function (p) {
      var v = p.get();
      if (!v || !matches(p, item.id)) return;
      item.properties = item.properties || {};
      if (item.properties[p.prop] === undefined) item.properties[p.prop] = v;
    });
  }

  function patchJson(text) {
    try {
      var d = JSON.parse(text);
      if (d && Object.prototype.toString.call(d.items) === '[object Array]') d.items.forEach(applyToItem);
      else if (d && d.id !== undefined) applyToItem(d);
      else return text;
      return JSON.stringify(d);
    } catch (e) { return text; }
  }

  function patchPairs(get, has, append) {
    var id = get('id');
    window.__gcpPickers.forEach(function (p) {
      var v = p.get();
      if (!v || !matches(p, id)) return;
      var k = 'properties[' + p.prop + ']';
      if (!has(k)) append(k, v);
    });
  }

  function patchSearchParams(sp) {
    patchPairs(function (k) { return sp.get(k); }, function (k) { return sp.has(k); }, function (k, v) { sp.append(k, v); });
    return sp;
  }

  function patchFormData(fd) {
    patchPairs(function (k) { return fd.get(k); }, function (k) { return fd.has(k); }, function (k, v) { fd.append(k, v); });
    return fd;
  }

  function isAdd(url) { return typeof url === 'string' && url.indexOf('/cart/add') !== -1; }

  function patchBody(body) {
    if (typeof body === 'string') {
      if (body.replace(/^\s+/, '').charAt(0) === '{') return patchJson(body);
      if (typeof URLSearchParams !== 'undefined') return patchSearchParams(new URLSearchParams(body)).toString();
      return body;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return patchFormData(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return patchSearchParams(body);
    return body;
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isAdd(url) && init && init.body !== undefined && init.body !== null) init.body = patchBody(init.body);
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__gcpUrl = url; return origOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isAdd(this.__gcpUrl) && body !== undefined && body !== null) return origSend.call(this, patchBody(body));
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  }
})();
